/**
 * same for frontend and backend. so frontend can count order!
 */

//from https://stackoverflow.com/questions/38923376/return-a-new-string-that-sorts-between-two-given-strings
function midString(prev, next) {
  var p, n, pos, str;
  for (pos = 0; p == n; pos++) {
    // find leftmost non-matching character
    p = pos < prev.length ? prev.charCodeAt(pos) : 96;
    n = pos < next.length ? next.charCodeAt(pos) : 123;
  }
  str = prev.slice(0, pos - 1); // copy identical part of string
  if (p == 96) {
    // prev string equals beginning of next
    while (n == 97) {
      // next character is 'a'
      n = pos < next.length ? next.charCodeAt(pos++) : 123; // get char from next
      str += "a"; // insert an 'a' to match the 'a'
    }
    if (n == 98) {
      // next character is 'b'
      str += "a"; // insert an 'a' to match the 'b'
      n = 123; // set to end of alphabet
    }
  } else if (p + 1 == n) {
    // found consecutive characters
    str += String.fromCharCode(p); // insert character from prev
    n = 123; // set to end of alphabet
    while ((p = pos < prev.length ? prev.charCodeAt(pos++) : 96) == 122) {
      // p='z'
      str += "z"; // insert 'z' to match 'z'
    }
  }

  const mCharCode = Math.ceil((p + n) / 2);
  const mChar = String.fromCharCode(mCharCode);

  return str + mChar; // append middle character
}

export default {
  minSeedValue: "aaaaaa",
  maxSeedValue: "zzzzzz",
  seedValue: "nnnnnn",
  minSeedValueFor: function(order) {
    if (!order) {
      return this.minSeedValue;
    }
    const res = "a".repeat(order.length);
    if (res == order) {
      return "a".repeat(order.length - 1);
    }
    return res;
  },
  maxSeedValueFor: function(order) {
    if (!order) {
      return this.maxSeedValue;
    }
    const res = "z".repeat(order.length);
    if (res == order) {
      return res + "z";
    }
    return res;
  },
  default: function() {
    return this.seedValue;
  },
  /**
   * return
   * -1 order1 < order2
   *  0 order1 == order2
   *  1 order1 > order2
   */
  compare: function(order1, order2) {
    if (!order1) {
      if (!order2) {
        return 0;
      }
      return -1;
    }

    if (!order2) {
      if (!order1) {
        return 0;
      }
      return 1;
    }

    if (this.isNeg(order1)) {
      if (this.isNeg(order2)) {
        return order1.localeCompare(order2) * -1;
      }
      return -1;
    }

    if (this.isNeg(order2)) {
      if (this.isNeg(order1)) {
        return order2.localeCompare(order1) * -1;
      }
      return 1;
    }

    return order1.localeCompare(order2);
  },
  isNeg(order) {
    return order && order.charCodeAt(0) == 45;
  },
  between: function(prevOrder, nextOrder) {
    if (!prevOrder && !nextOrder) {
      return this.seedValue;
    }

    if (!prevOrder) {
      return this.prev(nextOrder);
      //prevOrder = this.minSeedValueFor(nextOrder);
    }

    if (!nextOrder) {
      return this.next(prevOrder);
      //nextOrder = this.maxSeedValueFor(prevOrder);
    }

    if (this.isNeg(prevOrder)) {
      if (this.isNeg(nextOrder)) {
        return "-" + this.between(prevOrder.substring(1), nextOrder.substring(1));
      }

      return "-" + this.between(prevOrder.substring(1), "a".repeat(prevOrder.length - 1));
    }

    if (this.isNeg(nextOrder)) {
      if (this.isNeg(prevOrder)) {
        return "-" + this.between(prevOrder.substring(1), nextOrder.substring(1));
      }

      return "-" + this.between(nextOrder.substring(1), "a".repeat(nextOrder.length - 1));
    }

    const res = midString(prevOrder, nextOrder);
    const avLength = Math.ceil((prevOrder.length + nextOrder.length) / 2);
    if (res.length < avLength) {
      return res + "n".repeat(avLength - res.length);
    }

    return res;
  },
  next: function(order) {
    if (!order) return this.seedValue;
    if (this.isNeg(order)) {
      //already negative, so we should increment
      const prevResult = this.prev(order.substring(1));
      if (this.isNeg(prevResult)) {
        return prevResult.substring(1);
      }
      return "-" + prevResult;
    }

    let result = "";
    //a = 97
    //z = 122
    let ch;
    let isDone = false;
    for (let i = order.length - 1; i >= 0; i--) {
      if (isDone) {
        result = order[i] + result;
        continue;
      }

      ch = order.charCodeAt(i);
      if (ch > 121) {
        result = order[i] + result;
        continue;
      }

      result = String.fromCharCode(ch + 1) + result;
      isDone = true;
    }
    if (!isDone) {
      //если будут только z
      return "z".repeat(order.length) + "a";
    }
    return result;
  },
  prev: function(order) {
    if (!order) return this.seedValue;
    if (this.isNeg(order)) {
      //already negative, so we should increment
      return "-" + this.next(order.substring(1));
    }
    if (order == "a") return "-a";

    let result = "";
    //a = 97
    //z = 122
    let ch;
    let isDone = false;
    for (let i = order.length - 1; i >= 0; i--) {
      if (isDone) {
        result = order[i] + result;
        continue;
      }

      ch = order.charCodeAt(i);
      if (ch < 98) {
        result = order[i] + result;
        continue;
      }

      result = String.fromCharCode(ch - 1) + result;
      isDone = true;
    }
    if (!isDone) {
      return "-" + order;
      /*
      if (order.length < 3) {
        return this.between(this.minSeedValueFor(order), order);
      }
      //если будут только a
      return "a".repeat(order.length - 1);      
      */
    }
    return result;
  }
};
